export default "__VITE_ASSET__CBex6JJZ__"